import {
  apiUserAiduoDel,
  apiPracticeUnit,
  apiPracticeJob,
  apiPracticeRecord,
  apiAddexericise
} from '@/api/api.js'
import Audio from '@/components/Audio/Audio.vue'
import AudioTool from '@/components/AudioTool/AudioTool.vue'
// import Recorder from '@/components/Recorder/Recorder.vue'
import Recorder from '@/components/Recorder/RecorderWork.vue'
import VueVideo from '@/components/vue-video.vue'
import * as upload from '@/utils/upload'

export default {
  components: {
    Audio,
    AudioTool,
    Recorder,
    VueVideo
  },
  data() {
    return {
      resultData: [],
      practice_id: sessionStorage.getItem('practice_id'),
      caqid: sessionStorage.getItem('caqid'),
      job_end_time: sessionStorage.getItem('job_end_time'),
      isExpired: false,
      PccourseDetailTitle: sessionStorage.getItem('tcl_pccourse-detail_title'),
      userPractice: '',
      Delisible: false,
      SubmitDialogVisible: false,
      submitFunction: null, // 存储要调用的函数名
      del_item: '',
      del_index: '',
      del_pindex: '',
      answerVisible: false,
      page: 1,
      user_practice_unit: [],
      temp_practice_unit: [],
      assianStatus: 0,

      isRecorder: false,
      recoredUrl: null,
      recorders: [{ id: 1 }], // 初始有一个录音控件
      // recorders: [], // 初始有一个录音控件
      curId: 1, // 用于生成下一个录音控件的唯一ID
      showRecord: true,
      deleteDialogVisible: false,
      currentDeleteId: null,
      addlimitVisible: false,// 添加录音限制弹窗
      addlimit: 5,// 添加录音限制个数
      submitSuccessVisible: false,// 提交成功弹窗
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.isExpired = new Date() > new Date(this.job_end_time)
      this.showRecord = !this.isExpired
      console.log(this.isExpired)
      console.log(this.showRecord)
      console.log(this.job_end_time)
      this.getUcld()
    },
    // 显示删除确认对话框
    showDeleteConfirm(id) {
      this.currentDeleteId = id;
      this.deleteDialogVisible = true;
    },
    // 确认删除
    confirmDelete() {
      if (this.currentDeleteId) {
        this.removeRecorder(this.currentDeleteId);
        this.currentDeleteId = null;
      }
      this.deleteDialogVisible = false;
    },
    // 取消删除
    cancelDelete() {
      this.currentDeleteId = null;
      this.deleteDialogVisible = false;
    },
    getUcld() {
      let paramsBase = {
        id: this.practice_id,
        caqid: this.caqid
      }
      apiPracticeUnit(paramsBase).then((res) => {
        this.resultData = res.data.detail
        for (let i in this.resultData.inClass) {
          this.resultData[i] = this.resultData.inClass[i]
        }
        for (let j in this.resultData.sample) {
          this.resultData.sample = this.resultData.sample[j]
        }
        for (let k in this.resultData.rule) {
          this.resultData.rule = this.resultData.rule[k]
        }
        this.type = this.resultData.type
        this.getAssignment()
        //this.resultData.next_course = Object.values(this.resultData.next_course)
      })
    },

    getAssignment() {
      let paramsBase = {
        id: this.practice_id,
        caqid: this.caqid,
        page: this.page,
        type: this.type
      }
      apiPracticeJob(paramsBase).then((res) => {
        this.user_practice_unit = res.data.list
      })
    },
    getPractice() {
      let paramsBase = {
        id: this.practice_id,
        page: this.page,
        type: this.type
      }
      apiPracticeRecord(paramsBase).then((res) => {
        this.user_practice_unit = res.data.list
      })
    },
    load() {
      this.page++
      this.getSkillData()
    },
    handleStartRecorder() {
      this.recoredUrl = null
    },
    // getMsgFormSon(data) {
    //   const name = this.getMath() + this.getMath() + this.getMath() + '.wav'
    //   upload.file({
    //     file: data,
    //     fileName: name,
    //     onSuccess: ({ data }) => {
    //       this.isRecorder = true

    //       this.user_practice_unit = [
    //         {
    //           time: 'now',
    //           audio: data.oss_url
    //         }
    //       ]
    //       this.recoredUrl = data.oss_url
    //     }
    //   })
    // },
    // 修改 getMsgFormSon 方法以处理多个录音
  getMsgFormSon(data, id) {
    const name = this.getMath() + this.getMath() + this.getMath() + '.wav';
    upload.file({
      file: data,
      fileName: name,
      onSuccess: ({ data }) => {
        this.showRecord = false; // 隐藏录音控件

        this.isRecorder = true;
        
        // 找到对应的录音控件并更新其录音URL
        const recorderIndex = this.recorders.findIndex(r => r.id === id);
        if (recorderIndex !== -1) {
          this.$set(this.recorders, recorderIndex, {
            ...this.recorders[recorderIndex],
            audioUrl: data.oss_url
          });
        }
        
        // 更新用户练习单元列表
        const existingIndex = this.temp_practice_unit.findIndex(item => item.id === id);
        if (existingIndex !== -1) {
          this.$set(this.temp_practice_unit, existingIndex, {
            time: 'now',
            audio: data.oss_url,
            id: id
          });
        } else {
          this.temp_practice_unit.push({
            time: 'now',
            audio: data.oss_url,
            id: id
          });
        }
        
        this.recoredUrl = data.oss_url;
      }
      });
      console.log("this.temp_practice_unit")
      console.log(this.temp_practice_unit)
    },
    //生成随机数
    getMath() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    submitPracComfirm(type) {

      // 添加类型检查
      if (!['text', 'audio'].includes(type)) {
        this.$layer.msg('Invalid submit type')
        return;
      }

      // 设置对应的提交函数
      this.submitFunction = type === 'text' ? this.submit : this.submitPrac;
      this.SubmitDialogVisible = true;
      
    },
    submitPrac() {
      this.SubmitDialogVisible = false
      if (this.resultData.is_answered == 1) {
        this.$layer.msg('您已经完成此作业，请勿重复提交')
        return false
      }
      // let paramsBase = {
      //   id: this.practice_id,
      //   contents: this.recoredUrl,
      //   caqid: this.caqid
      // }
      // apiAddexericise(paramsBase).then((res) => {
      //   // this.resultData.user_practice_unit.push({
      //   //     content: urlValue,
      //   //     id: res.data.puid,
      //   // })
      //   this.userPractice = ''
      //   this.init()
      // })
      // 改为提交多个录音
      // 将 temp_practice_unit 数组转换为逗号分隔的音频 URL 字符串
      const audioString = this.temp_practice_unit.map(item => item.audio).join(',');

      let paramsBase = {
        id: this.practice_id,
        contents: audioString,
        caqid: this.caqid
      }
      apiAddexericise(paramsBase).then((res) => {
        this.submitSuccessVisible = true
        this.temp_practice_unit = []
        this.init()
      })
    },
    submit() {
      this.SubmitDialogVisible = false
      if (this.resultData.is_answered == 1) {
        this.$layer.msg('您已经完成此作业，请勿重复提交')
        return false
      }
      let paramsBase = {
        id: this.practice_id,
        contents: this.userPractice,
        caqid: this.caqid
      }
      apiAddexericise(paramsBase).then((res) => {
        // this.resultData.user_practice_unit.push({
        //     content: this.userPractice,
        //     id: res.data.puid,

        // })
        this.submitSuccessVisible = true
        this.userPractice = ''
        this.init()
      })
    },
    clickDelAudio(item, index, pindex) {
      this.del_item = item
      this.del_index = index
      this.del_pindex = pindex
      this.Delisible = true
    },
    clickDel() {
      this.resultData.user_practice_unit[this.del_pindex].content.splice(
        this.del_index,
        1
      )
      let paramsBase = {
        puid: this.del_item.id
      }
      apiUserAiduoDel(paramsBase).then((res) => {
        this.resultData.user_practice_unit.splice(this.del_index, 1)
      })
      this.Delisible = false
    },
    clickAgainExercise(id) {
      sessionStorage.setItem('tcl_ucld_id', id)
      let paramsBase = {
        ucld_id: id,
        lang: this.$i18n.locale
      }
      apiUcld(paramsBase).then((res) => {
        this.resultData = res.data
        this.resultData.next_course = Object.values(this.resultData.next_course)
      })
    },
    againExercise() {
      this.user_practice_unit = []
      this.userPractice = ''
    },
    viewAnswer() {
      this.answerVisible = true
    },
    selectMenu(num) {
      if (num == 0) {
        this.assianStatus = 0
        this.getAssignment()
      } else if (num == 1) {
        this.assianStatus = 1
        this.getPractice()
      }
    },
    prev() {
      this.$router.go(-1)
    },
    // 添加录音组件
    addRecorder() {
      if(this.recorders.length >= this.addlimit){
        this.addlimitVisible = true;
        return;
      }
      this.recorders.push({ id: ++this.curId });
      this.showRecord = true; // 显示录音组件
    },
    // 移除录音组件
    removeRecorder(id) {
      console.log("pre delete recorders:"+id)
      console.log(this.recorders)
      if (this.recorders.length > 0) {
        console.log("do delete recorders")
        this.recorders = this.recorders.filter(recorder => recorder.id !== id);
        console.log("after delte recorders:"+this.recorders.length)
        console.log(this.recorders)
      }
      if (this.temp_practice_unit.length > 0) {
        this.temp_practice_unit = this.temp_practice_unit.filter(item => item.id !== id);
      }
      if(this.recorders.length == 0){
        this.addRecorder()
        console.log("do add recorders")
        console.log(this.recorders)
      }
      console.log("final recorders:"+this.recorders.length)
      console.log(this.recorders)
    },
  }
}
